import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { useEffect, useRef, useState } from 'react'
import UsuarioServiceAPI from '../../service/UsuarioServiceAPI'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'

export default function RemessaUsuarios() {
  const toast = useRef()
  const userServiceApi = new UsuarioServiceAPI()
  const [file, setFile] = useState([])
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const handleFileChange = (e) => {
    setFile(e.target.files[0])
    if (e.target.files[0]) {
      toast.current.show({
        severity: 'success',
        summary: 'Arquivo anexado!',
        detail: 'Por favor confirme o upload!',
        life: 3000,
      })
    }
  }

  const handleSaveFile = async (e) => {
    e.preventDefault()

    if (file?.length == 0) {
      toast.current.show({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, selecione um arquivo antes de enviar',
        life: 3000,
      })
      return
    }

    setLoading(true)
    const formData = new FormData()
    formData.append('file', file)

    userServiceApi
      .uploadArquivoUsuario(formData)
      .then((data) => {
        toast.current.show({
          severity: 'success',
          summary: 'Sucesso!',
          detail: 'Arquivo de remessas enviado com sucesso!',
          life: 3000,
        })
        setTimeout(() => {
          history.push('/usuarios')
        }, 3000)
      })
      .catch((e) => {
        toast.current.show({
          severity: 'error',
          summary: 'Erro',
          detail: 'Houve um erro ao enviar seu arquivo, tente novamente!',
          life: 3000,
        })
      })
      .finally(() => {
        setLoading(false)
        setFile(null)
      })
  }

  return (
    <div className=''>
      <Toast ref={toast} />
      <h5 className='mb-4'>Upload remessa de usuários</h5>
      <form className='card' onSubmit={handleSaveFile}>
        <div
          className='flex flex-column align-items-center p-4'
          style={{ gap: 12 }}
        >
          <div className='flex flex-column align-items-center'>
            <i className='pi pi-cloud-upload' style={{ fontSize: '3rem' }}></i>
            <p>Selecione um arquivo e envie remessas de usuários</p>
          </div>
          <div className='flex align-items-center' style={{ gap: 8 }}>
            <label
              className='p-button flex justify-content-center align-items-center'
              htmlFor='sendFile'
              style={{ height: 33, gap: 4 }}
            >
              <i className='pi pi-cloud-upload'></i>
              <span>Anexar arquivo</span>
            </label>
            <input
              hidden
              type='file'
              accept='.xls,.xlsx'
              onChange={handleFileChange}
              disabled={loading}
              name=''
              id='sendFile'
            />
            <Button
              icon='pi pi-save'
              loading={loading}
              label='Enviar arquivos'
              disabled={file?.length == 0}
              className='p-button p-button-success'
              type='submit'
            />
          </div>
        </div>
      </form>
    </div>
  )
}
